<template>
  <form>
      <div class="row q-col-gutter-md">
        <div class="col col-12">
          <q-select
              v-model="WalletAddressObj.rebit_account_id"
              :label="$t('wallet-addresses.table_titles.owner')"
              emit-value
              map-options
              option-label="label"
              option-value="id"
              :options="owners"
              :error="WalletAddressObj.errors.has('rebit_account_id')"
              :error-message="WalletAddressObj.errors.get('rebit_account_id')"
              color="input-color"
          />
        </div> <!-- NETWORK -->
        <div class="col col-xs-12 col-md-6 col-lg-6">
          <q-input
              v-model="WalletAddressObj.address"
              :label="$t('wallet-addresses.table_titles.address')"
              lazy-rules
              :error="WalletAddressObj.errors.has('address')"
              :error-message="WalletAddressObj.errors.get('address')"
              :rules="[ val => val && val.length > 0 || $t('wallet-addresses.table_titles.address') + ' is required!']"
              color="input-color"
          />
        </div> <!-- Address -->
        <div class="col col-xs-12 col-md-6 col-lg-6">
            <q-select
                v-model="WalletAddressObj.network"
                :label="$t('wallet-addresses.table_titles.network')"
                clearable
                emit-value
                map-options
                option-label="label"
                option-value="value"
                :options="networks"
                :error="WalletAddressObj.errors.has('network')"
                :error-message="WalletAddressObj.errors.get('network')"
                color="input-color"
            />
        </div> <!-- NETWORK -->
        <div class="col col-xs-12 col-sm-6 col-md-3">
            <p class="text-caption q-pb-xs" style="margin:0">Status</p>
            <q-toggle
                v-model="WalletAddressObj.is_active"
                :label="WalletAddressObj.is_active ? 'Active' : 'Deactivate'"
                color="green"
                checked-icon="fa fa-check"
                unchecked-icon="fa fa-uncheck"
            />
        </div> <!-- IS ACTIVE -->
      </div>
    </form>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  name: 'Form',
  model: {
    prop: 'WalletAddressObj',
    event: 'change'
  },
  props: {
    WalletAddressObj: {
      type: Object,
      required: true
    }
  },
  computed: {
      ...mapGetters(['rebit_accounts'])
  },
  data() {
    return {
        networks: [
            {label: '<span class="text-bold">TRX</span> Tron (TRC20)', value: 'TRC20'},
            {label: '<span class="text-bold">ETH</span> Ethereum (ERC20)', value: 'ERC20'},
            {label: '<span class="text-bold">BSC</span> BNB Smart Chain (BEP20)', value: 'BEP20'},
            {label: '<span class="text-bold">Account</span> number', value: 'ACCOUNT'},
            {label: '<span class="text-bold">Card</span> number', value: 'CARD'},
            {label: '<span class="text-bold">IBAN</span> code', value: 'IBAN'},
            {label: '<span class="text-bold">ID</span>', value: 'ID'},
        ],
        owners: []
    }
  },
  methods: {

  },
  created() {
      this.owners = this.rebit_accounts.filter(item => ['Wallet address', 'Account'].includes(item.type))
  },
  components: {},
}
</script>

